webpackJsonp([20],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(279);


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	/*
	 ** 全局域名等变量维护 复用个人中心
	 ** 127.0.0.1  127.0.0.1  proxy
	 ** focus-dev  .focus-dev || .focustest
	 ** focus-dev  .focus-dev || .focustest
	 ** focus  .focus
	 */
	
	'use strict';
	
	var byProxy = false;
	var mainDomain, oldMainDomain, loginUrl, otherDomain, loginDomain;
	
	/* 本地开发走proxy */
	if (/\d+\.\d+\.\d+\.\d+/.test(location.host)) {
	    byProxy = true;
	    //loginUrl = "//login.focus-dev.cn/login";
	}
	/* 测试线上等环境 */
	if (!byProxy) {
	    var hostArr = location.hostname.split('.');
	
	    // 旧项目测试环境 .focustest  新项目.focus-dev||.focus-test等
	    mainDomain = '.' + hostArr[hostArr.length - 2] + '.' + hostArr[hostArr.length - 1];
	    otherDomain = mainDomain;
	
	    if (/(focus-(.*))/.test(location.host)) {
	        oldMainDomain = '.focustest.cn';
	        //loginUrl = "//fe" + mainDomain + "/login";
	        loginUrl = '//login' + mainDomain + '/login';
	
	        var matched = /((focus-(test|dev))\d+\.cn)/.exec(location.host);
	        if (matched && matched[0]) {
	            //比如feature走fe
	            otherDomain = '.' + matched[2] + '.cn';
	            loginUrl = '//fe' + mainDomain + '/login';
	            loginDomain = '//fe' + mainDomain;
	        }
	    } else {
	        oldMainDomain = '.focus.cn';
	        loginUrl = '//login.focus.cn/login';
	    }
	}
	
	module.exports = {
	    mock: false,
	    mainDomain: byProxy ? '127.0.0.1' : mainDomain,
	    oldMainDomain: oldMainDomain,
	
	    // 生态接口拼图规则
	    PHOTO_DOMAIN: 'https://t4-res.focus-img.cn',
	    PHOTO_STYLE_L: 'sh345x190sh',
	    /* 直播 */
	    PHOTO_STYLE_A: 'sh210x150sh',
	    /* 文章 */
	    PHOTO_STYLE_H: 'sh50x50sh',
	    PHOTO_STYLE_LIVE: 'sh373x373sh',
	
	    /* 头像 */
	
	    // 默认图
	    'dftPhoto': 'https://t-res.focus-img.cn/mp/rz/753815f7-8a82-4506-8905-f880c2931cef.png%26t%3D1490064374316',
	
	    // 登录登出页规则
	    'loginUrl': byProxy ? '/login' : loginUrl,
	    'logoutUrl': byProxy ? '/login/logout' : loginUrl + '/logout',
	
	    // 直播页访问规则
	    'url_live': byProxy ? 'https://zhibo.focus-dev.cn/page/live-share.html' : 'https://zhibo' + mainDomain + '/page/live-share.html',
	
	    'uDomain': byProxy ? '' : '//u' + mainDomain,
	    'loginDomain': byProxy ? '' : '//login' + mainDomain,
	    // 本地测试绑定qq/sina功能，请绑定后端host,并切换loginDomain
	    //"loginDomain": byProxy ? "//login.focustest.cn" : "//login" + mainDomain,
	
	    // h5主站
	    'h5Domain': byProxy ? 'http://m.focus-dev.cn' : '//m' + mainDomain,
	
	    // 入驻 文章
	    'mpsvDomain': byProxy ? '/mock' : '//mp-sv-extend' + otherDomain,
	    // 入驻
	    'mpDomain': byProxy ? '' : '//mp' + otherDomain,
	
	    // 直播
	    'liveDomain': byProxy ? '' : '//api-zhibo' + otherDomain,
	    //
	    'accountInfo': byProxy ? '' : '//mp-fe-pc' + otherDomain,
	    // bbs
	    'bbsDomain': byProxy ? 'http://bbs.focus-dev.cn' : '//bbs' + otherDomain
	};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $$ajax = __webpack_require__(32);
	
	var $$config = __webpack_require__(30);
	
	var isLogin = function isLogin() {
	    if (!window.focus_uid) {
	        if (window.env === 'pc') {
	            window.FCLoginHeader && FCLoginHeader.open();
	        } else {
	            window.location.href = $$config.loginUrl + '?ru=' + window.encodeURIComponent(window.location.href);
	        }
	        return false;
	    }
	    return true;
	};
	
	module.exports = {
	    concern: function concern(uid, fn) {
	        if (!isLogin()) {
	            return;
	        }
	        var _this = this;
	        var data = {
	            appId: '1100',
	            followUid: uid || window.uid
	        };
	        $$ajax.post($$config.uDomain + '/api/v1/follow', data, fn);
	    },
	    unConcern: function unConcern(uid, fn) {
	        if (!isLogin()) {
	            return;
	        }
	        var _this = this;
	        var data = {
	            appId: '1100',
	            unfollowUid: uid || window.uid
	        };
	        $$ajax.post($$config.uDomain + '/api/v1/unfollow', data, fn);
	    },
	    infoGet: function infoGet(uid, fn) {
	        // if(!isLogin()){
	        //     return;
	        // }
	        var data = {
	            uid: uid || window.uid
	        };
	        $$ajax.get($$config.accountInfo + '/user/profile/information', data, fn);
	    },
	    isLogin: isLogin
	};

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $$config = __webpack_require__(30);
	var $$request = __webpack_require__(33);
	
	module.exports = {
	    get: function get(url, data, fn) {
	        $$request.ajax({
	            url: $$config.mock ? '/mock' + url : url,
	            data: data,
	            type: 'GET',
	            dataType: 'application/json',
	            withCredentials: true,
	            complete: function complete(data) {
	                var newData = {};
	                newData.code = data.code;
	                newData.msg = data.msg;
	                newData.data = data.data;
	                if (typeof fn === 'function') {
	                    fn(newData);
	                }
	            }
	        });
	    },
	
	    post: function post(url, data, fn) {
	        $$request.ajax({
	            url: $$config.mock ? '/mock' + url : url,
	            data: data,
	            type: 'POST',
	            dataType: 'application/json',
	            withCredentials: true,
	            complete: function complete(data) {
	                var newData = {};
	                newData.code = data.code;
	                newData.msg = data.msg;
	                newData.data = data.data;
	                if (typeof fn === 'function') {
	                    fn(newData);
	                }
	            }
	        });
	    }
	};

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		module.exports = __webpack_require__(3);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		var fnAddHeaders = function (headers, xmlhttp) {
		    var key, val;
		    for (key in headers) {
		        if (!headers.hasOwnProperty(key)) {
		            continue;
		        }
		        val = headers[key];
		        xmlhttp.setRequestHeader(key, val);
		    }
		};
	
		var fnIsCrossDomain = function (url) {
		    if (url.match(/^\/\//)) {
		        url = window.location.protocol + url;
		    }
	
		    var rurl = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
		    var ajaxLocParts = rurl.exec(window.location.href.toLowerCase()) || [];
		    var parts = rurl.exec(url.toLowerCase());
	
		    return crossDomain = !!(
		        parts &&
		            (parts[1] !== ajaxLocParts[1] ||
		              parts[2] !== ajaxLocParts[2] ||
		              (parts[3] ||
		                (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] ||
		                  (ajaxLocParts[1] === "http:" ? "80" : "443")))
		    );
		};
	
		// url {String}
		// method {String}
		// headers {Object}
		// body {String}
		// credentials {Boolean}
		// complete {Function}
		var fnXmlHttpRequest = function (url, method, headers, body, credentials, complete) {
		    var fnFormatParams = function () {
		        var fnFormatHeaders = function () {
		            // header
		            if (headers instanceof Object !== true) {
		                headers = {};
		            }
	
		            // X-Requested-With
		            if (fnIsCrossDomain(url) !== true) {
		                headers['X-Requested-With'] = 'XMLHttpRequest';
		            }
	
		            // Accept
		            headers.Accept = typeof headers.Accept !== 'string' ? '*/*' : headers.Accept;
		        };
	
		        if (typeof url !== 'string' || url === '') {
		            url = window.location.href;
		        }
	
		        if (typeof method !== 'string') {
		            method = 'GET';
		        }
	
		        fnFormatHeaders();
	
		        credentials = (fnIsCrossDomain(url) === true && credentials === true) ? true : false ;
	
		        body = typeof body === 'string' ? body : '';
		    };
	
		    var fn = function () {
				// alert(JSON.stringify(this))
	
		        if (this.readyState === 3) {
		            this.responseHeader = this.getAllResponseHeaders();
		        }
		        if (this.readyState === 4) {
		            if (typeof complete === 'function') {
		                complete(this);
		            }
		        }
		    };
	
		    fnFormatParams();
	
		    var xmlhttp = new XMLHttpRequest();
		    xmlhttp.onreadystatechange = fn;
		    xmlhttp.open(method, url, true);
		    fnAddHeaders(headers, xmlhttp);
		    xmlhttp.withCredentials = credentials;
		    xmlhttp.send(body);
		};
	
	
		exports.ajax = fnXmlHttpRequest;
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		var separator = '[[[SP]]]';
	
	
		var callbackStorage = {};
	
	
		var Messager = {};
	
	
		Messager.createListener = function (target) {
		    var callback = function (msg) {
		        if (typeof msg !== 'object') {
		            return;
		        }
	
		        // 验证是否是匹配的信息
		        msg = typeof msg.data === 'string' ? msg.data : '';
		        msg = msg.split(separator);
		        if (msg.length !== 2) {
		            return;
		        }
	
		        // 执行用户自定义回调
		        callbackStorage[msg[0]] = callbackStorage[msg[0]] || [];
		        var fns = callbackStorage[msg[0]];
		        var i;
		        for (i = 0; i < fns.length; i++) {
		            fns[i](msg[1]);
		        }
		    };
	
		    if ('addEventListener' in window.document) {
		        target.addEventListener('message', callback, false);
		    } else if ('attachEvent' in document) {
		        target.attachEvent('onmessage', callback);
		    }
		};
	
	
		Messager.listen = function (category, fn) {
		    callbackStorage[category] = callbackStorage[category] || [];
		    if (typeof fn === 'function') {
		        callbackStorage[category].push(fn);
		    }
		};
	
	
		Messager.post = function (target, category, msg) {
		    if (typeof msg !== 'string') {
		        console.log('msg should be string');
		        return;
		    }
		    target.postMessage(category + separator + msg, '*');
		};
	
	
		exports.Messager = Messager;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $$request = __webpack_require__(1);
		var $$requestIframe = __webpack_require__(4);
		var $$limit = __webpack_require__(5);
		var $$querystring = __webpack_require__(7);
		__webpack_require__(10);
	
	
		var request = {
		    // params {object}
		    // params.url {string}
		    // params.type {string}
		    // params.data {object}
		    // params.complete {function}
		    // params.contentType {string}
		    // params.withCredentials {boolean}
		    // params.cache {boolean}
		    ajax: function (params) {
		        params = $$limit.requestFormat(params);
	
		        var url = params.url;
		        var type = params.type;
		        var headers = {};
		        var body = '';
	
		        var fnInitParams = function () {
		            // type
		            var methods = [ 'GET', 'POST' ];
		            if (typeof params.type !== 'string' || methods.indexOf(params.type.toUpperCase()) < 0) {
		                params.type = 'GET';
		            }
	
		            // Content-Type
		            if (params.type === 'POST') {
		                if (typeof params.contentType === 'string' && params.contentType.indexOf('application/json') >= 0) {
		                    headers['Content-Type'] = 'application/json; charset=UTF-8';
		                } else {
		                    headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
		                }
		            }
	
		            // body
		            var paramsDataString = $$querystring.stringify(params.data);
		            if (params.type === 'GET') {
		                if (paramsDataString && paramsDataString !== '') {
		                    if (params.url.indexOf('?') >= 0) {
		                        url += '&' + paramsDataString;
		                    } else {
		                        url += '?' + paramsDataString;
		                    }
		                }
		            }
	
		            if (params.type === 'POST') {
		                if (typeof params.contentType === 'string' && params.contentType.indexOf('application/json') >= 0 ) {
		                    body = JSON.stringify(params.data);
		                } else {
		                    body = $$querystring.stringify(params.data);
		                }
		            }
	
		            // cache
		            if (params.cache !== false) {
		                if (url.indexOf('?') >= 0) {
		                    url += '&_t=' + (+new Date());
		                } else {
		                    url += '?_t=' + (+new Date());
		                }
		            }
		        };
		        fnInitParams();
	
		        var fn = function (xhr) {
		            var data;
	
		            if (!xhr || typeof xhr.responseText !== 'string') {
		                data = {
		                    code: 'LR-01',
		                    msg: '请求失败',
		                    data: {}
		                }
		                console.error('[LIB-REQUEST] [SERVER ERROR]');
		            } else {
		                try {
		                    data = JSON.parse(xhr.responseText);
		                } catch (e) {
		                    data = {
		                        code: 'LR-02',
		                        msg: 'JSON格式化错误',
		                        data: {}
		                    }
		                    console.error('[LIB-REQUEST] [PARSE JSON ERROR]');
		                }
		            }
	
		            if (typeof params.complete === 'function') {
		                data = $$limit.responseFormat(data);
		                params.complete(data);
		            }
		        };
	
		        var fnIsCrossDomain = function () {
		            if (url.match(/^\/\//)) {
		                url = window.location.protocol + url;
		            }
	
		            var rurl = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/;
		            var ajaxLocParts = rurl.exec(window.location.href.toLowerCase()) || [];
		            var parts = rurl.exec(url.toLowerCase());
	
		            return crossDomain = !!(
		                parts &&
		                    (parts[1] !== ajaxLocParts[1] ||
		                      parts[2] !== ajaxLocParts[2] ||
		                      (parts[3] ||
		                        (parts[1] === "http:" ? "80" : "443")) !== (ajaxLocParts[3] ||
		                          (ajaxLocParts[1] === "http:" ? "80" : "443")))
		            );
		        };
	
		        var isIframe = false;
		        if (fnIsCrossDomain()) {
		            if (window.navigator.userAgent.indexOf('MSIE 9.0') >= 0) {
		                isIframe = true;
		            }
		            if (window.navigator.userAgent.indexOf('MSIE 8.0') >= 0) {
		                isIframe = true;
		            }
		        }
		        if (isIframe) {
		            $$requestIframe.ajax(url, type, headers, body, params.withCredentials, fn);
		        } else {
		            $$request.ajax(url, type, headers, body, params.withCredentials, fn);
		        }
		    },
		    request: function (url, type, headers, body, withCredentials, fn) {
		        $$request.ajax(url, type, headers, body, withCredentials, fn);
		    },
		    requestByIframe: function (url, type, headers, body, withCredentials, fn) {
		        $$requestIframe.ajax(url, type, headers, body, withCredentials, fn);
		    },
		    pushWhiteList: function (url, key) {
		        $$limit.pushWhiteList(url, key);
		    },
		    pushParamsWhiteList: function (url, key) {
		        $$limit.pushParamsWhiteList(url, key);
		    }
		};
	
	
		module.exports = request;
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Messager = __webpack_require__(2).Messager;
	
		var fnGetMessager = (function () {
		    var messagerStorage = {};
	
		    var mapFnKeyStorage = {};
	
		    var messagerTag = Math.random();
	
		    var fnCreateIframe = function (domain) {
		        var protocol = window.location.protocol;
		        var iframe = window.document.createElement('iframe');
		        iframe.src = protocol + '//' + domain + '/crossdomain.html?tag=' + messagerTag;
		        iframe.style.display = 'none';
		        window.document.body.appendChild(iframe);
	
		        return iframe;
		    };
	
		    var fn = function (domain, fn) {
		        var messager = messagerStorage[domain] || {};
	
		        if (messager.ready === false) {
		            messager.readyFns = messager.readyFns || [];
		            messager.readyFns.push(fn);
		            return;
		        }
	
		        if (messager.ready === true) {
		            fn && fn(messager);
		            return;
		        }
	
		        // create messager
		        messager.frame = fnCreateIframe(domain);
		        messager.ready = false;
		        messager.readyFns = [ fn ];
		        messager.post = function (msg, fn) {
		            var key = 'key-' + (+new Date()) + window.Math.random().toFixed(15);
		            msg = key + ',' + encodeURIComponent(msg);
		            mapFnKeyStorage[key] = fn;
		            Messager.post(messager.frame.contentWindow, messagerTag + ',' + domain + ',' + 'child', msg);
		        };
		        messagerStorage[domain] = messager;
	
		        // listen
		        Messager.listen(messagerTag + ',' + domain + ',' + 'parent', function(msg) {
		            if (msg === '[[ready]]') {
		                messager.ready = true;
		                (function () {
		                    var i, fn;
		                    for (i = 0; i < messager.readyFns.length; i++) {
		                        fn = messager.readyFns[i];
		                        fn && fn(messager);
		                    }
		                }());
		            } else {
		                msg = msg.split(',');
		                mapFnKeyStorage[msg[0]] && mapFnKeyStorage[msg[0]](decodeURIComponent(msg[1]));
		            }
		        });
		    };
	
		    Messager.createListener(window);
	
		    return fn;
		}());
	
		var fnRequest = function (opt, fn) {
		    var domain = opt.url.match(/\/\/(.*?)\//);
		    if (domain) {
		        domain = domain[1];
		    } else {
		        domain = window.location.host;
		    }
	
		    fnGetMessager(domain, function (messager) {
		        var msg = JSON.stringify(opt);
	
		        messager.post(msg, function (msg) {
		            msg = JSON.parse(msg);
		            fn && fn(msg);
		        });
		    });
		};
	
		var fnAjax = function (url, method, headers, body, credentials, complete) {
		    var opt = {
		        url: url,
		        method: method,
		        headers: headers,
		        body: body,
		        credentials: credentials
		    };
	
		    fnRequest(opt, complete);
		};
	
		exports.ajax = fnAjax;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		var $$util = __webpack_require__(6);
		var $$querystring = __webpack_require__(7);
		var responseWhiteList = {};
		var requestWhiteList = {};
	
	
		var limit = {
		    requestFormat: function (params) {
		        var fnValidateQueryString = function (data) {
		            var fnValidate = function (key, val) {
		                var msg = '[LIB-REQUEST] [REQUEST FEILD ERROR] [' + key + ': ' + val + ']';
	
		                if (val instanceof Object === true) {
		                    console.error(msg);
		                    return false;
		                }
	
		                if (typeof val !== 'string') {
		                    val = JSON.stringify(val) || '';
		                }
	
		                while (val.indexOf('%') >= 0) {
		                    try {
		                        val = decodeURIComponent(val);
		                    } catch(e) {
		                        break;
		                    }
		                }
	
		                try {
		                    val = JSON.parse(val);
		                    if (val instanceof Object === true) {
		                        console.error(msg);
		                        return false;
		                    }
		                } catch (e) {}
	
		                return true;
		            };
	
		            var formatMap = {};
		            var key, val;
		            for (key in data) {
		                if (!data.hasOwnProperty(key)) {
		                    continue;
		                }
		                val = data[key];
		                if (fnValidate(key, val) === true) {
		                    formatMap[key] = val;
		                }
		            }
	
		            return formatMap;
		        };
	
		        var fnValidateUrl = function (url) {
		            if (typeof url !== 'string' || url === '') {
		                url = window.location.href;
		            }
	
		            var qs = url.split('?')[1];
		            var obj = $$querystring.parse(qs);
		            qs = $$querystring.stringify(fnValidateQueryString(obj));
		            if (qs && qs !== '') {
		                return url.split('?')[0] + '?' + qs;
		            } else {
		                return url.split('?')[0];
		            }
		        };
	
		        var fnValidateJson = function (data) {
		            if (data instanceof Object === false) {
		                return {};
		            }
	
		            var fnWalkObject, fnWalkArray;
	
		            fnWalkArray = function (array) {
		                var tbasic = false;
		                var tobject = false;
		                var isOneKeyObject = true;
	
		                $$util.arrayClear(array);
	
		                array.forEach(function (item, i) {
		                    var it = $$util.type(item);
		                    if (it === 'array') {
		                        array[i] = '[LIB-REQUEST] [REQUEST ARRAY ERROR]';
		                        return;
		                    }
		                    if (it === 'object') {
		                        tobject = true;
		                        if ($$util.getObjectKeys(item).length > 1) {
		                            isOneKeyObject = false;
		                        }
		                        return;
		                    }
		                    tbasic = true;
		                });
	
		                if (tbasic === true && tobject === true) {
		                    array = '[LIB-REQUEST] [REQUEST ARRAY ERROR]';
		                    return;
		                }
	
		                if (tobject === true && array.length > 0 && isOneKeyObject === true) {
		                    (function () {
		                        var key = $$util.getObjectKeys(array[0])[0];
		                        array.forEach(function (item, i) {
		                            array[i] = item[key];
		                        });
		                    }());
		                    return;
		                }
	
		                if (tobject === true && array.length > 0 && isOneKeyObject === false) {
		                    array.forEach(function (item) {
		                        fnWalkObject(item);
		                    });
		                }
		            };
	
		            fnWalkObject = function (object) {
		                var key, val, vt;
		                for (key in object) {
		                    if (!object.hasOwnProperty(key)) {
		                        continue;
		                    }
		                    val = object[key];
		                    vt = $$util.type(val);
		                    if (vt === 'object') {
		                        if (val === null) {
		                            delete object[key];
		                        } else if ($$util.isEmptyObject(val)) {
		                            delete object[key];
		                        } else {
		                            fnWalkObject(val);
		                        }
		                    } else if (vt === 'array') {
		                        fnWalkArray(val);
		                    } else if (vt === 'undefined') {
		                        delete object[key];
		                    }
		                }
		            };
	
		            fnWalkObject(data);
	
		            return data;
		        };
	
		        // url
		        params.url = fnValidateUrl(params.url);
	
		        // data
		        if (params.type === 'POST' && params.contentType === 'application/json') {
		            params.data = fnValidateJson(params.data);
		        } else {
		            params.data = fnValidateQueryString(params.data);
		        }
	
		        return params;
		    },
		    responseFormat: function (data) {
		        var fnValidateStructure = function (data) {
		            var msg = '[LIB-REQUEST] [RESPONSE STRUCTURE ERROR]';
		            var vdata = {
		                code: 'LR-03',
		                msg: msg,
		                data: {}
		            };
	
		            if (data instanceof Object === false) {
		                data = vdata;
		            }
	
		            var ctype = $$util.type(data.code);
		            var mtype = $$util.type(data.msg);
		            var dtype = $$util.type(data.data);
	
		            var pass = true;
	
		            if (['number', 'string'].indexOf(ctype) < 0) {
		                data.code = vdata.code;
		                pass = false;
		            }
		            if (['string'].indexOf(mtype) < 0) {
		                data.msg = vdata.msg;
		                pass = false;
		            }
		            if (['number', 'boolean', 'string', 'array', 'object'].indexOf(dtype) < 0) {
		                data.data = vdata.data;
		                pass = false;
		            }
	
		            return data;
		        };
	
		        var fnProcessApi = function (data) {
		            if (data instanceof Object === false) {
		                return {};
		            }
	
		            var fnWalkObject, fnWalkArray;
	
		            fnWalkArray = function (array) {
		                var tbasic = false;
		                var tobject = false;
		                var tarray = false;
		                var isOneKeyObject = true;
	
		                $$util.arrayClear(array);
	
		                array.forEach(function (item, i) {
		                    var it = $$util.type(item);
		                    if (it === 'array') {
		                        array[i] = '[LIB-REQUEST] [RESPONSE ARRAY ERROR]';
		                        return;
		                    }
		                    if (it === 'object') {
		                        tobject = true;
		                        if ($$util.getObjectKeys(item).length > 1) {
		                            isOneKeyObject = false;
		                        }
		                        return;
		                    }
		                    tbasic = true;
		                });
	
		                if (tbasic === true && tobject === true) {
		                    array = '[LIB-REQUEST] [RESPONSE ARRAY ERROR]';
		                    return;
		                }
	
		                // one key
		                if (tobject === true && array.length > 0 && isOneKeyObject === true) {
		                    (function () {
		                        var key = $$util.getObjectKeys(array[0])[0];
		                        array.forEach(function (item, i) {
		                            array[i] = item[key];
		                        });
		                    }());
		                    return;
		                }
	
		                // basic
		                if (tbasic === true && tobject === false) {
		                    array.forEach(function (item, i) {
		                        array[i] = item.toString();
		                    });
		                    return;
		                }
	
		                // object
		                if (tobject === true && array.length > 0 && isOneKeyObject === false) {
		                    array.forEach(function (item) {
		                        fnWalkObject(item);
		                    });
		                }
		            };
	
		            fnWalkObject = function (object) {
		                var key, val, vt;
		                for (key in object) {
		                    if (!object.hasOwnProperty(key)) {
		                        continue;
		                    }
		                    val = object[key];
		                    vt = $$util.type(val);
		                    if (vt === 'object') {
		                        if (val === null) {
		                            delete object[key];
		                        } else if ($$util.isEmptyObject(val)) {
		                            delete object[key];
		                        } else {
		                            fnWalkObject(val);
		                        }
		                    } else if (vt === 'array') {
		                        fnWalkArray(val);
		                    } else if (vt === 'undefined') {
		                        delete object[key];
		                    } else {
		                        try {
		                            object[key] = val.toString();
		                        } catch (e) {}
		                    }
		                }
		            };
	
		            fnWalkObject(data);
	
		            return data;
		        };
	
		        data = fnValidateStructure(data);
		        data = fnProcessApi(data);
	
		        return data;
		    },
		    pushWhiteList: function (url, key) {
		        if (typeof url !== 'string' || url === '') {
		            return;
		        }
		        if (typeof key !== 'string' || key === '') {
		            return;
		        }
		        responseWhiteList[url] = responseWhiteList[url] || [];
		        responseWhiteList[url].push(key);
		    },
		    pushParamsWhiteList: function (url, key) {
		        if (typeof url !== 'string' || url === '') {
		            return;
		        }
		        if (typeof key !== 'string' || key === '') {
		            return;
		        }
		        requestWhiteList[url] = requestWhiteList[url] || [];
		        requestWhiteList[url].push(key);
		    }
		};
	
	
		module.exports = limit;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		exports.type = function (val) {
		    var t = typeof val;
		    if (t === 'object' && val instanceof Array === true) {
		        t = 'array';
		    }
		    return t;
		};
	
		exports.isEmptyObject = function (object) {
		    var _this = this;
		    if (_this.type(object) !== 'object') {
		        return false;
		    }
	
		    var key;
		    for (key in object) {
		        if (object.hasOwnProperty(key)) {
		            return false;
		        }
		    }
		    return true;
		};
	
		exports.arrayClear = function (array, val) {
		    var _this = this;
		    var cnt = 0;
		    var i, item;
		    var match;
		    var i1;
		    for (i = 0; i < array.length; i++) {
		        match = false;
		        item = array[i];
		        if (item === null) {
		            match = true;
		        } else if (item === undefined) {
		            match = true;
		        } else if (_this.type(item) === 'object' && JSON.stringify(item) === '{}') {
		            match = true;
		        }
	
		        if (match) {
		            for (i1 = i; i1 < array.length; i1++) {
		                array[i1] = array[i1 + 1];
		            }
		            array.length = array.length - 1;
		        }
		    }
		};
	
		exports.getObjectKeys = function (object) {
		    var akey = [];
		    var key;
		    for (key in object) {
		        if (object.hasOwnProperty(key)) {
		            akey.push(key);
		        }
		    }
		    return akey;
		};
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.decode = exports.parse = __webpack_require__(8);
		exports.encode = exports.stringify = __webpack_require__(9);
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		'use strict';
	
		// If obj.hasOwnProperty has been overridden, then calling
		// obj.hasOwnProperty(prop) will break.
		// See: https://github.com/joyent/node/issues/1707
		function hasOwnProperty(obj, prop) {
		  return Object.prototype.hasOwnProperty.call(obj, prop);
		}
	
		module.exports = function(qs, sep, eq, options) {
		  sep = sep || '&';
		  eq = eq || '=';
		  var obj = {};
	
		  if (typeof qs !== 'string' || qs.length === 0) {
		    return obj;
		  }
	
		  var regexp = /\+/g;
		  qs = qs.split(sep);
	
		  var maxKeys = 1000;
		  if (options && typeof options.maxKeys === 'number') {
		    maxKeys = options.maxKeys;
		  }
	
		  var len = qs.length;
		  // maxKeys <= 0 means that we should not limit keys count
		  if (maxKeys > 0 && len > maxKeys) {
		    len = maxKeys;
		  }
	
		  for (var i = 0; i < len; ++i) {
		    var x = qs[i].replace(regexp, '%20'),
		        idx = x.indexOf(eq),
		        kstr, vstr, k, v;
	
		    if (idx >= 0) {
		      kstr = x.substr(0, idx);
		      vstr = x.substr(idx + 1);
		    } else {
		      kstr = x;
		      vstr = '';
		    }
	
		    k = decodeURIComponent(kstr);
		    v = decodeURIComponent(vstr);
	
		    if (!hasOwnProperty(obj, k)) {
		      obj[k] = v;
		    } else if (isArray(obj[k])) {
		      obj[k].push(v);
		    } else {
		      obj[k] = [obj[k], v];
		    }
		  }
	
		  return obj;
		};
	
		var isArray = Array.isArray || function (xs) {
		  return Object.prototype.toString.call(xs) === '[object Array]';
		};
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		// Copyright Joyent, Inc. and other Node contributors.
		//
		// Permission is hereby granted, free of charge, to any person obtaining a
		// copy of this software and associated documentation files (the
		// "Software"), to deal in the Software without restriction, including
		// without limitation the rights to use, copy, modify, merge, publish,
		// distribute, sublicense, and/or sell copies of the Software, and to permit
		// persons to whom the Software is furnished to do so, subject to the
		// following conditions:
		//
		// The above copyright notice and this permission notice shall be included
		// in all copies or substantial portions of the Software.
		//
		// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
		// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
		// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
		// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
		// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
		// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
		// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
		'use strict';
	
		var stringifyPrimitive = function(v) {
		  switch (typeof v) {
		    case 'string':
		      return v;
	
		    case 'boolean':
		      return v ? 'true' : 'false';
	
		    case 'number':
		      return isFinite(v) ? v : '';
	
		    default:
		      return '';
		  }
		};
	
		module.exports = function(obj, sep, eq, name) {
		  sep = sep || '&';
		  eq = eq || '=';
		  if (obj === null) {
		    obj = undefined;
		  }
	
		  if (typeof obj === 'object') {
		    return map(objectKeys(obj), function(k) {
		      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
		      if (isArray(obj[k])) {
		        return map(obj[k], function(v) {
		          return ks + encodeURIComponent(stringifyPrimitive(v));
		        }).join(sep);
		      } else {
		        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
		      }
		    }).join(sep);
	
		  }
	
		  if (!name) return '';
		  return encodeURIComponent(stringifyPrimitive(name)) + eq +
		         encodeURIComponent(stringifyPrimitive(obj));
		};
	
		var isArray = Array.isArray || function (xs) {
		  return Object.prototype.toString.call(xs) === '[object Array]';
		};
	
		function map (xs, f) {
		  if (xs.map) return xs.map(f);
		  var res = [];
		  for (var i = 0; i < xs.length; i++) {
		    res.push(f(xs[i], i));
		  }
		  return res;
		}
	
		var objectKeys = Object.keys || function (obj) {
		  var res = [];
		  for (var key in obj) {
		    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
		  }
		  return res;
		};
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		/*---------------------------------------*
		* Array
		*---------------------------------------*/
		(function (ap) {
		    // indexOf
		    if (ap.indexOf) {
		        return;
		    }
	
		    ap.indexOf = function (val) {
		        var i, item;
		        for (i = 0; i < this.length; i++) {
		            item = this[i];
		            if (val === item) {
		                break;
		            }
		        }
	
		        if (i < this.length) {
		            return i;
		        } else {
		            return -1;
		        }
		    };
	
		    // forEach
		    if (ap.forEach) {
		        return;
		    }
	
		    ap.forEach = function (fn) {
		        if (typeof fn !== 'function') {
		            return;
		        }
	
		        var i, item;
		        for (i = 0; i < this.length; i++) {
		            item = this[i];
		            fn.call(this, item, i);
		        }
		    };
		}(Array.prototype));
	
	
	/***/ }
	/******/ ])
	});
	;


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $$ajax = __webpack_require__(32);
	
	var $$config = __webpack_require__(30);
	
	module.exports = {
	
	    getMoreComment: function getMoreComment(uid, pageNo, pageSize, fn) {
	
	        var _this = this;
	        var data = {
	            uid: uid || window.uid,
	            pageNo: pageNo,
	            pageSize: pageSize
	        };
	
	        $$ajax.get($$config.uDomain + '/api/v1/comment/project/list', data, fn);
	    },
	    replyUserDianping: function replyUserDianping(commentId, comment, fn) {
	        var _this = this;
	        var data = {
	            commentId: commentId,
	            userDiscuss: comment
	
	        };
	
	        $$ajax.post($$config.uDomain + '/api/v1/comment/project/reply', data, fn);
	    }
	};

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	var _fn = function () {};
	
	function LoadMore(config) {
	    var dftCfg = {
	        btn: $(".load-more"),
	        hide: true,
	        prevent: _fn,
	        trigger: "scroll"
	
	    };
	
	    this.config = $.extend({}, dftCfg, config);
	
	    this.loadMoreBtn = this.config.btn;
	    this.canLoadFlag = !this.config.hide;
	
	    this.$mod = this.config.mod;
	
	    this.lazyLoad();
	
	}
	
	LoadMore.prototype = {
	    btn: function () {
	        return this.loadMoreBtn;
	    },
	    enable: function () {
	        this.canLoadFlag = true;
	    },
	    disable: function () {
	        this.canLoadFlag = false;
	    },
	
	    trigger: function (cb) {
	        var that = this;
	
	        if (this.config.hide) {
	            return;
	        }
	
	        $(window).on('scroll', _.throttle(function () {
	            
	
	            if (typeof that.config.prevent === 'function' && that.config.prevent()) {
	                return;
	            }
	            if (that.canLoadFlag && that.loadMoreBtn) {
	                var scrollHeight = window.scrollY || document.body.scrollTop || $(window).scrollTop(),
	                    documentHeight = document.body.scrollHeight || document.body.offsetHeight || $('body').height(),
	                    deviceHeight = window.innerHeight ||  document.documentElement.clientHeight || $(window).height();
	                var isSafari = navigator.userAgent.indexOf("Safari") > -1;
	
	                var cond = that.config.trigger === "scroll" ?
	                    isSafari ?
	                    scrollHeight >= documentHeight - (deviceHeight + 50) :
	                    scrollHeight >= documentHeight - deviceHeight :
	                    scrollHeight >= that.loadMoreBtn.offset().top + that.loadMoreBtn
	                    .outerHeight() - deviceHeight;
	
	                if (cond) {
	                    that.canLoadFlag = false;
	
	                    that.loadMoreBtn.siblings('.icon').addClass('loading');
	                    if (that.config.trigger === "pcScroll") {
	                        that.loadMoreBtn.html('<em></em>正在加载更多');
	
	                        that.scrollLoc = $(document).scrollTop();
	
	                    } else {
	                        that.loadMoreBtn.html('加载中');
	
	                    }
	
	                    if (typeof cb === 'function') {
	                        cb();
	                    }
	                }
	            }
	        }, 200))
	
	    },
	
	    lazyLoad: function () {
	        if (this.$mod) {
	            this.$mod.find('.lazy-img').lazyload({
	                threshold: 80,
	                effect: "fadeIn"
	
	            });
	        }
	
	    },
	
	    renderMore: function (list_tpl, context, wrapper) {
	        var Velocity = window.velocityjs;
	
	        var html = Velocity.render(list_tpl, context)
	
	        wrapper.html(wrapper.html() + html);
	
	        this.lazyLoad();
	    },
	
	    hide: function () {
	
	        this.canLoadFlag = true;
	        this.loadMoreBtn.hide();
	    },
	
	
	    show: function () {
	        this.canLoadFlag = true;
	        if (this.config.trigger === "scroll") {
	            this.loadMoreBtn.html('上滑加载更多...').removeClass('loading').show();
	
	        } else if (this.config.trigger === "pcScroll") {
	            this.goBack();
	            this.loadMoreBtn.html('滑动加载更多').show();
	
	        }
	    },
	
	    noMore: function () {
	        if (this.config.trigger === "scroll") {
	            this.canLoadFlag = false;
	
	            this.loadMoreBtn.siblings('.icon').removeClass('loading').addClass('smile');
	            this.loadMoreBtn.html('没有啦');
	        } else if (this.config.trigger === "pcScroll") {
	            this.canLoadFlag = false;
	            this.goBack();
	            this.loadMoreBtn.remove();
	        }
	    },
	
	
	    noMorePost: function () {
	        if (this.config.trigger === "scroll") {
	            this.canLoadFlag = false;
	
	            this.loadMoreBtn.siblings('.icon').removeClass('loading').removeClass('smile');
	            this.loadMoreBtn.html('只展示当前用户30条帖子');
	
	        } else if (this.config.trigger === "pcScroll") {
	            this.canLoadFlag = false;
	
	            this.loadMoreBtn.html('只展示当前用户30条帖子');
	
	        }
	    },
	
	    goBack: function () {
	        if (this.config.trigger === "pcScroll") {
	
	            $(document).scrollTop(this.scrollLoc)
	        };
	    }
	
	};
	
	module.exports = LoadMore;


/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	// require('script/util/response.js')
	'use strict';
	
	var $$config = __webpack_require__(30);
	
	var $$model = __webpack_require__(31);
	
	$(function () {
	    var $mod = $('.module-profile-header');
	
	    var shareBtn = $mod.find('[node-type="share-btn"]');
	    var attendBtn = $mod.find('[node-type="attend-btn-wrap"] .action');
	    var letterBtn = $mod.find('[node-type="letter-btn"]');
	    var logoImg = $mod.find('[node-type="profile-logo"]');
	
	    var recommendText = $mod.find('[node-type="recommend-text"]'),
	        moreBtn = $mod.find('[node-type="recommend-more-btn"]');
	
	    var accountLink = $mod.find('.account-link');
	    var accountWin = $mod.find('.account-win');
	    var accountRes = {};
	    $$model.infoGet(window.uid, function (res) {
	        console.log(res, 'res');
	        if (!res.data) {
	            accountLink.css('display', 'none');
	        } else {
	            accountLink.css('display', 'inline-block');
	            accountRes = res.data;
	        }
	    });
	    accountLink.on('click', function () {
	        accountWin.toggleClass('show');
	        accountLink.addClass('click');
	        if (!window.focus_uid) {
	            accountWin.find('.account-default').show();
	        } else {
	            if (accountRes.type === '自媒体-个人' || accountRes.type === '家居设计师' || accountRes.type === '家居工长') {
	                accountWin.find('.account-personal').find('.type-content').text(accountRes.type);
	                if (accountRes.address) {
	                    accountWin.find('.account-personal').find('.address-content').text(accountRes.address);
	                } else {
	                    accountWin.find('.account-personal').find('.personal-address').css('display', 'none');
	                }
	                accountWin.find('.account-personal').show();
	            } else {
	                accountWin.find('.account-company').find('.type-content').text(accountRes.type);
	                if (accountRes.organizationName) {
	                    accountWin.find('.account-company').find('.name-content').text(accountRes.organizationName);
	                } else {
	                    accountWin.find('.account-company').find('.company-name').css('display', 'none');
	                }
	                if (accountRes.organizationCode) {
	                    accountWin.find('.account-company').find('.code-content').text(accountRes.organizationCode);
	                } else {
	                    accountWin.find('.account-company').find('.company-code').css('display', 'none');
	                }
	                accountWin.find('.account-company').show();
	            }
	        }
	    });
	    accountWin.find('.account-default').on('click', function () {
	        window.FCLoginHeader && FCLoginHeader.open();
	    });
	    $('.mask').on('click', function (e) {
	        console.log('test', e.target);
	        if (accountWin.hasClass('show')) {
	            console.log('wwve');
	            accountWin.removeClass('show');
	            accountLink.removeClass('click');
	        }
	    });
	
	    moreBtn.on('click', function () {
	        if (recommendText.hasClass('limited')) {
	            recommendText.removeClass('limited');
	            moreBtn.html('收起<i></i>');
	            moreBtn.addClass('up');
	            // $mod.find('.info').css('height', 'auto')
	        } else {
	            recommendText.addClass('limited');
	            moreBtn.html('展开<i></i>');
	            moreBtn.removeClass('up');
	            // $mod.find('.info').css('height', '96px')
	        }
	    });
	
	    letterBtn.on('click', function () {
	        if (window.uid) {
	            location.href = $$config.uDomain + '#letter-contact?toAccount=' + window.uid;
	        } else {
	            location.href = $$config.loginUrl + '?ru=' + encodeURIComponent($$config.uDomain + '#letter-contact?toAccount=' + window.uid);
	        }
	    });
	
	    /* 关注 */
	    attendBtn.on('click', function () {
	        if (!window.isFollow) {
	            $$model.concern(window.uid, concernCb);
	        } else {
	            $$model.unConcern(window.uid, unConcernCb);
	        }
	    });
	
	    function concernCb(res) {
	        if (res.code !== '200') {
	            window.toast(res.msg);
	        } else {
	            window.isFollow = true;
	            attendBtn.removeClass('attend-btn').addClass('attended-btn');
	            attendBtn.html('已关注');
	        }
	    };
	
	    function unConcernCb(res) {
	        if (res.code !== '200') {
	            window.toast(res.msg);
	        } else {
	            window.isFollow = false;
	            // attendBtn.off('tap');
	            attendBtn.html('关注');
	            attendBtn.removeClass('attended-btn').addClass('attend-btn');
	        }
	    };
	
	    // 头像加载失败显示默认
	    (function () {
	        var oImg = new Image();
	        oImg.onerror = function () {
	            logoImg.attr('src', 'https://t1-res.focus-img.cn/sh145x145sh/misc/noavatar.png'); // 焦点默认图
	        };
	        oImg.src = logoImg.attr('src');
	    })();
	});

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	'use strict';
	
	$(function () {
	
	    var $mod = $('.module-pannel-menu');
	    //关于
	    var navs = $mod.find('.attention-nav.action .cell');
	    var tabContents = $('.module-global-tab');
	
	    /*navs.on('click', function () {
	         var _self = $(this);
	        navs.removeClass('cur');
	        _self.addClass('cur');
	         tabContents.removeClass('cur');
	        tabContents.eq(_self.index()).addClass('cur');
	         // 资讯和直播 哎。。
	        if (_self.index() === 1) {
	            $mod.find('.article-count').show();
	         } else {
	            $mod.find('.article-count').hide();
	         }
	        if (_self.index() === 2) {
	            $mod.find('.live-count').show();
	        } else {
	            $mod.find('.live-count').hide();
	        }
	        if (_self.index() === 6) {
	            $mod.find('.design-count').show();
	        } else {
	            $mod.find('.design-count').hide();
	        }
	        if (_self.index() === 7) {
	            $mod.find('.zhuangxiu-count').show();
	        } else {
	            $mod.find('.zhuangxiu-count').hide();
	        }
	         if (_self.index() === 8) {
	            $mod.find('.staff-count').show();
	        } else {
	            $mod.find('.staff-count').hide();
	        }
	    });*/
	    var index = window.location.href.lastIndexOf('/');
	    if (document.domain == '127.0.0.1') {
	        var param = window.location.href.substr(index + 9); //test和本地不一致
	    } else {
	        var param = window.location.href.substr(index + 1); //test和本地不一致
	    }
	
	    navs.each(function () {
	        if ($(this).hasClass(param)) {
	
	            $(this).addClass('cur');
	        }
	    });
	});
	/*if (param == 'zixun') {
	    $('.article-count').addClass('cur');
	}else {
	    if (param == 'zhibo') {
	        $('.live-count').addClass('cur');
	    }else {
	        if (param == 'sheji') {
	            $('.design-count').addClass('cur');
	        }else {
	            if (param == 'zhuangxiu') {
	                $('.zhuangxiu-count').addClass('cur');
	            }else {
	                if (param == 'shejishi' || param == 'gongzhang') {
	                    $('.staff-count').addClass('cur');
	                }
	            }
	        }
	    }
	}*/
	/*navs.on('click', function () {
	     var _self = $(this);
	    navs.removeClass('cur');
	    _self.addClass('cur');
	     tabContents.removeClass('cur');
	    tabContents.eq(_self.index()).addClass('cur');
	    var param = $(this).attr('class').split(' ')[0];
	    var domain = document.domain;
	    if (domain == '127.0.0.1') {
	        window.location.href = '/page-pc-'+param;//本地和测试不同，需要改
	    }else {
	        window.location.href = window.location.href +'/'+param
	    }
	});*/

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $$model_comment = __webpack_require__(54);
	var $$list_tpl = __webpack_require__(197);
	var $$config = __webpack_require__(30);
	var LoadMore = __webpack_require__(56);
	
	$(function () {
	    var $mod = $('.module-pannel-comment');
	    var pageNo = 1;
	    var uid = +$('[node-type="comment-list"]').attr('data-uid');
	    var hasMore = $('[node-type="comment-list"]').attr('data-hasMore');
	    var $dianpingList = $mod.find('[node-type="comment-list"]');
	    var $commentMenus = $mod.find('[node-type="comment-menu"]');
	    var loadMoreBtn = $mod.find('[node-type="load-more"]');
	
	    // var userName = $mod.find('[node-type="dianping-username"]').val();
	
	    var $$loadMore = new LoadMore({
	        mod: $mod,
	        btn: loadMoreBtn,
	        hide: hasMore === 'false' || !hasMore,
	        trigger: 'pcScroll'
	    });
	
	    var isLogin = function isLogin() {
	
	        if (!window.focus_uid) {
	            FCLogin.open();
	
	            // window.location.href = $$config.loginUrl + '?ru=' + window.encodeURIComponent(window.location.href);
	            return false;
	        }
	        return true;
	    };
	    var headerStarFn = function headerStarFn($ele) {
	        //点评评分星星
	        var len = $ele.length,
	            i;
	        for (i = 0; i < len; i++) {
	            var cur = $ele.eq(i);
	            var score = cur.attr('data-score'),
	                width = cur.width(),
	                curWidth = width / 5 * score;
	            cur.find('.star-cnt').width(curWidth);
	        }
	    };
	
	    var dianZan = function dianZan() {
	
	        $mod.on('click', '[node-type="dianping-zan"]', function () {
	            if ($(this).data('voted')) {
	                return;
	            }
	            var $zanCount = $(this).find('.bottom-zan-num');
	            $zanCount.html(+$zanCount.html() + 1);
	            $(this).data('voted', true);
	        });
	    };
	
	    var commentInput = function commentInput() {
	        $mod.delegate('input[node-type=\'comment-input\']', 'input propertychange change', function () {
	            var _this = window.$(this);
	            var val = _this.val().toString();
	            if (val.length > 0) {
	                $mod.find('[node-type="comment-btn"]').removeClass('disabled');
	            } else {
	                $mod.find('[node-type="comment-btn"]').addClass('disabled');
	            }
	        });
	    };
	    var commentFn = function commentFn() {
	        //回复按钮
	        $dianpingList.delegate('[node-type="dianping-comment"]', 'click', function () {
	            // if (!isLogin()) {
	            //     return;
	            // }
	            var $this = $(this);
	            var $parent = $this.parents('[node-type="dianping-list-item"]'),
	                $commentMenu = $parent.find('[node-type="comment-menu"]');
	            if ($commentMenu.is(':visible')) {
	                $commentMenu.hide();
	            } else {
	                $commentMenus.hide();
	                $commentMenu.show();
	            }
	        });
	    };
	
	    var commentMenuFn = function commentMenuFn() {
	        //回复下拉菜单
	        $dianpingList.delegate('[node-type="comment-btn"]', 'click', function () {
	            var $this = $(this);
	
	            if ($this.hasClass('disabled')) {
	                return;
	            } else {
	                $this.addClass('disabled');
	            }
	
	            var $input = $this.siblings('[node-type="comment-input"]'),
	                $parent = $this.parents('[node-type="comment-menu"]'),
	                $comment = $this.parents('[node-type="dianping-list-item"]').find('[node-type="dianping-comment"]');
	            var commentId = +$parent.attr('data-id'),
	                content = $input.val().trim(),
	                commentNum = $comment.find('.bottom-comment-num').html();
	            if (content === '') {
	                //为空提示
	                window.toast('请输入点评内容');
	                $this.removeClass('disabled');
	                return;
	            } else if (content.length < 10) {
	                window.toast('最少输入10个字');
	                $this.removeClass('disabled');
	                return;
	            } else if (content.length > 200) {
	                window.toast('最多输入200个字');
	                $this.removeClass('disabled');
	                return;
	            } else {
	                $$model_comment.replyUserDianping(commentId, content, function (res) {
	                    if (res.code === '200') {
	                        var data = {
	                            'name': '我',
	                            'replyTxt': content
	                        };
	                        var $$tmpl = __webpack_require__(198);
	                        $parent.find('[node-type="comment-cnt"]').prepend(velocityjs.render($$tmpl, data));
	                        $input.val('');
	                        $comment.addClass('light').find('.bottom-comment-num').html(++commentNum);
	                        $this.addClass('disabled');
	                        window.toast('发送成功');
	                    } else {
	                        if (!focus_uid) {
	                            window.toast('请先登录');
	                        } else {
	                            window.toast('发送失败');
	                        }
	                    }
	                    $this.removeClass('disabled');
	                });
	            }
	        });
	    };
	
	    $$loadMore.trigger(function () {
	        $$model_comment.getMoreComment(uid, ++pageNo, 10, getMoreCommentCb);
	    });
	    // 监听回调函数
	    function getMoreCommentCb(data) {
	
	        if (data.code === '200' || data.code === 200) {
	
	            var context = {
	
	                'commentInfo': {
	                    'list': data.data.list
	
	                },
	                'focus_domain': $mod.data('domain'),
	                'PHOTO_DOMAIN': $mod.attr('data-photoDomain'),
	                'dftLoupanImg': $mod.attr('data-dftImg'),
	                'PHOTO_STYLE_H': $mod.attr('data-photoStyle')
	            };
	
	            $$loadMore.renderMore($$list_tpl, context, $mod.find('[node-type="comment-list"]'));
	
	            headerStarFn($mod.find('[node-type="dianping-list-star"]'));
	
	            if (data.data.hasNext === 'false') {
	                $$loadMore.noMore();
	
	                return;
	            }
	            $$loadMore.show();
	        } else {
	            $$loadMore.hide();
	        }
	    };
	
	    headerStarFn($mod.find('[node-type="dianping-list-star"]'));
	    headerStarFn($mod.find('[node-type="dianping-header-star"]'));
	    commentFn();
	    commentInput();
	    commentMenuFn();
	    dianZan();
	});

/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	module.exports = "#foreach($item in ${commentInfo.list})\n    <div class=\"pannel-dianping-item\" data-id=\"${item.id}\" user-id=\"${item.userId}\" data-more=\"${commentInfo.hasNext}\" node-type=\"dianping-list-item\">\n        <div class=\"info-wrap\">\n            #if($!{item.linkPc})\n            <a href=\"$!{item.linkPc}\" class=\"left-logo\">\n            #end\n                #if(${item.projPhotoPath})\n                <img src=\"$!{item.projPhotoPrefix}$!{PHOTO_STYLE_H}$!{item.projPhotoPath}\" class=\"header-user-img\"/>\n                #else\n                <img src=\"$!{dftLoupanImg}\" class=\"header-user-img\"/>\n                #end\n            #if($!{item.linkPc})\n            </a>\n            #end\n\n            <div class=\"right-info\">\n\n                <div class=\"list-item-header \">\n\n                    #set($starDescList = [\n                        \"0分差评\",\n                        \"没兴趣\",\n                        \"纠结中\",\n                        \"想看看\",\n                        \"有计划\",\n                        \"真想买\"\n                    ])\n                    #set($starDescIndex = 5)\n                    #if($!{item.averageRate} <= 4)\n                    #set($starDescIndex = 4)\n                    #end\n                    #if($!{item.averageRate} <= 3)\n                    #set($starDescIndex = 3)\n                    #end\n                    #if($!{item.averageRate} <= 2)\n                    #set($starDescIndex = 2)\n                    #end\n                    #if($!{item.averageRate} <= 1)\n                    #set($starDescIndex = 1)\n                    #end\n                        #if($!{item.projPhotoPath})\n                        <a href=\"$!{item.linkPc}\">\n                        #end\n                            #if(${item.isCream})\n                            <p class=\"header-info-name\">${item.projName}</p>\n                            #else\n                            <p class=\"header-info-name\">${item.projName}</p>\n                            #end\n                        #if($!{item.projPhotoPath})\n                        </a>\n                        #end\n                <div class=\"header-info cell\">\n\n                        <div class=\"header-info-star\">\n                            <span class=\"info-star\" data-score=\"${item.averageRate}\" node-type=\"dianping-list-star\">\n                                <i class=\"star-bg\"></i>\n                                <i class=\"star-cnt\"></i>\n                                <i class=\"star-top\"></i>\n                            </span>\n                            <span class=\"info-star-buy\">$starDescList[$starDescIndex]</span>\n                        </div>\n\n                    <div class=\"list-item-score \">\n                        <div class=\"score-item\">价格<span class=\"score-item-num\">$!{item.priceRate}</span></div>\n                        <div class=\"score-line cell\"></div>\n                        <div class=\"score-item\">地段<span class=\"score-item-num\">$!{item.addressRate}</span></div>\n                        <div class=\"score-line cell\"></div>\n                        <div class=\"score-item\">交通<span class=\"score-item-num\">$!{item.transportRate}</span></div>\n                        <div class=\"score-line cell\"></div>\n                        <div class=\"score-item\">配套<span class=\"score-item-num\">$!{item.facilitiesRate}</span></div>\n                        <div class=\"score-line cell\"></div>\n                        <div class=\"score-item\">环境<span class=\"score-item-num\">$!{item.envRate}</span></div>\n                    </div>\n                    </div>\n                </div>\n\n                <p class=\"list-item-para\" style=\"-webkit-box-orient: vertical\">$!{item.projComment}</p>\n                <div class=\"list-item-bottom clearfix\">\n                    <div class=\"bottom-time\">$!{item.createTime}</div>\n                    <div class=\"bottom-comment \" node-type=\"dianping-comment\">回复(<span class=\"bottom-comment-num\">$!{item.replyCountFormat}</span>)</div>\n\n                    <div class=\"bottom-zan \" node-type=\"dianping-zan\">有用(<span class=\"bottom-zan-num\">$!{item.upCountFormat}</span>)</div>\n\n                </div>\n\n\n            </div>\n            </div>\n\n\n\n                <div class=\"list-item-comment\" node-type=\"comment-menu\" data-id=\"${item.id}\">\n                    <div class=\"comment-cnt-arrow\"></div>\n                    <div class=\"comment-form \">\n                        <input type=\"text\" class=\"comment-form-input cell\" node-type=\"comment-input\"/>\n                        <a href=\"javascript:;\" class=\"comment-form-btn disabled\" node-type=\"comment-btn\">发送</a>\n                    </div>\n                    <div class=\"comment-cnt\" node-type=\"comment-cnt\">\n                        #foreach($comment in $item.replyList)\n                        <div class=\"comment-cnt-item\">\n                            <div class=\"comment-cnt-item-tit\">\n                                <span class=\"name\">#if($comment.userId == $focus_uid)我 #else $!{comment.nickName}#end</span> 回复 ：</span>\n                            </div>\n                            <p class=\"comment-cnt-item-para\">${comment.userDiscuss}</p>\n                        </div>\n                        #end\n                    </div>\n                </div>\n\n\n    </div>\n\n#end\n"

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	module.exports = "<div class=\"comment-cnt-item\">\r\n    <div class=\"comment-cnt-item-tit\">\r\n        <span class=\"name\">${name}</span> 回复 ：\r\n    </div>\r\n    <p class=\"comment-cnt-item-para\">${replyTxt}</p>\r\n</div>\r\n"

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	"use strict";

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	'use strict';
	
	$(function () {
	    var $mod = $('.module-right-toolbar'),
	        goTop = $mod.find('.top');
	
	    var needFixToRight = function needFixToRight() {
	        if ($(window).width() <= 1440) {
	            $mod.css({
	                'left': 'auto',
	                'right': '0'
	            });
	        }
	    };
	
	    var needShow = function needShow() {
	
	        if ($(window).scrollTop() >= $('.module-pannel-menu').offset().top - 10) {
	            goTop.css({
	                'display': 'block'
	            }).show();
	        } else {
	            goTop.hide();
	        }
	    };
	
	    $mod.find('.top').click(function () {
	        window.scrollTo(0, 0);
	    });
	
	    $(window).on('scroll', _.throttle(needShow, 200));
	
	    needShow();
	    needFixToRight();
	});

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	/**
	 * @author jl
	 * @version  2016-10-14
	 * @description 底部选择js
	 */
	// build module
	"use strict";
	
	$(function () {});

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(166);
	
	__webpack_require__(280);
	
	__webpack_require__(170);
	__webpack_require__(172);
	
	__webpack_require__(173);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(196);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(275);

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// profile-pc-dianping/profile-pc-dianping.a6b496af280b69693f90.js